import React from 'react';

export const SourceEntity = (props) => {
    return (
        <li className="sourceEntity" key={props.id} onClick={
            () => props.onSourceSetter({ id: props.id, path: props.path })
        }>
            {props.path}
        </li>
    )
}


// WEBPACK FOOTER //
// ./src/components/sourcePicker/SourceEntity.js